export default function PDPAModalTHView(props) {
  return (
    <iframe title="pdpa_en" src="/pdpa_en.pdf" width="100%" height="700" />
  )
}
